var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',_vm._b({attrs:{"type":"submit","disabled":_vm.waiting}},'b-button',_vm.$attrs,false),[(!_vm.waiting)?_vm._t("default"):[_c('b-spinner',{attrs:{"variant":"light","small":""}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }